export default __webpack_public_path__ + "static/media/haesli-i-dae-gruebe.6e113c5f.png";